<template>
<div>
  <div>
    <v-text-field
      v-model="search"
      prepend-inner-icon="mdi-magnify"
      label="キーワード検索"
      outlined
      hide-details
      dense
      style="
        width: 320px;
        border-radius: 8px;
        margin-bottom: 15px;
      "
      >
    </v-text-field>
  </div>
  <VuePerfectScrollbar
    fluid
    style="height: 60vh; overflow-y: auto"
  >
    <table
      class="table_1 table_2"
      style="width: 100%"
    >
      <tr style="position: sticky !important; top: 0 !important">
        <th style="min-width: 20px; max-width: 20px">
          <input
            @change="toggleAllCheck"
            v-model="allCheck"
            type="checkbox"
            class="office-staff-checkbox"
            style="height:"
          />
        </th>
        <th
          style="min-width: 150px; max-width: 150px"
          colspan="2"
        >
          勤務区分名
        </th>
        <th style="min-width: 180px; max-width: 180px">外部連携先勤務区分ID</th>
        <th style="min-width: 160px; max-width: 160px">勤務種別</th>
        <th style="min-width: 100px; max-width: 100px">勤務カテゴリ</th>
        <th style="min-width: 96px; max-width: 96px">勤務開始</th>
        <th style="min-width: 96px; max-width: 96px">勤務終了</th>
        <th style="min-width: 96px; max-width: 96px">勤務時間</th>
        <th style="min-width: 96px; max-width: 96px">休憩開始</th>
        <th style="min-width: 96px; max-width: 96px">休憩終了</th>
        <th style="min-width: 96px; max-width: 96px">休憩時間</th>
      </tr>
      <tr
        v-for="{
          id,
          name,
          category_ja,
          type_ja,
          working_start_time,
          working_end_time,
          working_hours,
          rest_start_time,
          rest_end_time,
          rest_time,
          external_kintais,
        } in filteredWorkpatterns"
        :key="id"
      >
        <td style="max-width: 20px; max-width: 20px">
          <input
            @change="handleWorkpatternChecked"
            v-model="form.workpatterns"
            type="checkbox"
            :value="id"
            class="office-staff-checkbox"
          />
        </td>
        <td style="min-width: 150px; max-width: 150px">{{ name }}</td>
        <td style="min-width: 180px; max-width: 180px">
          {{ external_kintais.map(kintai => `${kintai.name}: ${kintai.external_link_id}`).join(', ') }}
        </td>
        <td style="min-width: 160px; max-width: 160px">{{ type_ja }}</td>
        <td style="min-width: 100px; max-width: 100px">{{ category_ja }}</td>
        <td style="min-width: 96px; max-width: 96px">{{ working_start_time || `--:--` }}</td>
        <td style="min-width: 96px; max-width: 96px">{{ working_end_time || `--:--` }}</td>
        <td style="min-width: 96px; max-width: 96px">{{ working_hours || `--:--` }}</td>
        <td style="min-width: 96px; max-width: 96px">{{ rest_start_time || `--:--` }}</td>
        <td style="min-width: 96px; max-width: 96px">{{ rest_end_time || `--:--` }}</td>
        <td style="min-width: 96px; max-width: 96px">{{ rest_time || `--:--` }}</td>
      </tr>
    </table>
  </VuePerfectScrollbar>
</div>
</template>

<script>
import axios from 'axios';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    VuePerfectScrollbar,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    workpatterns: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      allCheck: false,
      search: '',
    };
  },
  methods: {
    updateLoading(flg) {
      EventBus.$emit('updateLoading', flg);
    },
    async isOfficeHasStaffHavingTheWorkpattern(workpatternIds) {
      const url = this.$route('office-staff-workpattern.index');
      const res = await axios.get(url, {
        params: {
          office_ids: [this.form.id],
          workpattern_ids: workpatternIds,
        },
      });

      return res.data.length > 0;
    },
    async swalProceedUncheck() {
      const { isConfirmed } = await this.$swal({
        icon: 'warning',
        text: '職員に紐づいている勤務区分も削除されますがよろしいですか？シフトパターンに指定されている固定シフトも対象です。',
        showCancelButton: true,
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      });

      return isConfirmed;
    },
    swalErrorAlert() {
      this.$swal({
        icon: 'error',
        text: 'エラーが発生しました。再度お試しください。',
      });
    },
    /**
     * 全ての勤務区分を選択または解除する
     * 'allCheck' が true の場合、全ての勤務区分を選択
     * 'allCheck' が false の場合、全ての勤務区分を解除
     */
    async toggleAllCheck() {
      // チェックを入れた場合、全ての勤務区分を選択する
      if (this.allCheck) {
        this.$set(this.form, 'workpatterns', this.allWorkpatternIds);
        this.$emit('change');
        return;
      }

      // 以下、チェックを外した場合の処理

      // 編集でない(新規作成・コピー)場合、そのまま全チェックを外す
      if (!this.isEdit) {
        this.$set(this.form, 'workpatterns', []);
        this.$emit('change');
        return;
      }

      try {
        this.updateLoading(true);

        // 職員に紐づいている勤務区分がない場合、そのまま全ての勤務区分を解除する
        if (!(await this.isOfficeHasStaffHavingTheWorkpattern(this.allWorkpatternIds))) {
          this.$set(this.form, 'workpatterns', []);
          this.$emit('change');
          return;
        }
      } catch (error) {
        this.swalErrorAlert();
        this.allCheck = true;
        return;
      } finally {
        this.updateLoading(false);
      }

      // 職員に紐づいている勤務区分がある場合、確認ダイアログを表示
      if (await this.swalProceedUncheck()) {
        // 確認ダイアログで「はい」を選択した場合、全ての勤務区分を解除する
        this.$set(this.form, 'workpatterns', []);
        this.$emit('change');
      } else {
        // 確認ダイアログで「キャンセル」を選択した場合、全選択のチェックボックスを元に戻す（オンにする）
        this.allCheck = true;
      }
    },
    async handleWorkpatternChecked(e) {
      // チェックを入れた場合、そのままチェックを入れる
      if (e.target.checked) {
        this.$emit('change');
        return;
      }

      // 以下、チェックを外した場合の処理

      // 編集でない場合(勤務区分IDがない場合）は何もしない
      if (!this.isEdit) {
        this.$emit('change');
        this.allCheck = false;
        return;
      }

      const workpatternId = Number.parseInt(e.target.value);

      try {
        this.updateLoading(true);

        if (!(await this.isOfficeHasStaffHavingTheWorkpattern([workpatternId]))) {
          this.$emit('change');
          this.allCheck = false;
          return;
        }
      } catch (error) {
        this.swalErrorAlert();
        this.form.workpatterns.push(workpatternId);
        return;
      } finally {
        this.updateLoading(false);
      }

      // 職員に紐づいている勤務区分がある場合、確認ダイアログを表示
      if (await this.swalProceedUncheck()) {
        // 確認ダイアログで「はい」を選択した場合
        this.$emit('change');
        this.allCheck = false; // 全選択のチェックを外す
      } else {
        // 確認ダイアログで「キャンセル」を選択した場合、チェックを入れ直す
        this.form.workpatterns.push(workpatternId); 
      }
    },
  },
  computed: {
    // 新規作成(および複製)かどうか
    isEdit() {
      return this.form.id;
    },
    // 全ての勤務区分IDを配列で返す
    allWorkpatternIds() {
      return this.workpatterns.map(({ id }) => id);
    },
    //　キーワード検索結果を返す
    filteredWorkpatterns() {
      const searchTerm = this.search.toLowerCase();
      return this.workpatterns.filter(pattern =>
        pattern.name.toLowerCase().includes(searchTerm) ||        // 勤務区分名で検索
        pattern.external_kintais
          .map(kintai => `${kintai.name} ${kintai.external_link_id}`)
          .join(', ').toLowerCase().includes(searchTerm) ||       // 外部連携先勤務区分IDで検索
        pattern.category_ja.toLowerCase().includes(searchTerm) || // 勤務カテゴリで検索
        pattern.type_ja.toLowerCase().includes(searchTerm)        // 勤務種別で検索
      );
    },
  },
};
</script>
